export interface PrimaryColorsModel {
  primary: string;
  secondary: string;
  tertiary: string;
  tertiaryContrast: string;
}
